import { render, staticRenderFns } from "./ClientNutritionInstructionItem.vue?vue&type=template&id=1ece3dc6&scoped=true"
import script from "./ClientNutritionInstructionItem.vue?vue&type=script&lang=js"
export * from "./ClientNutritionInstructionItem.vue?vue&type=script&lang=js"
import style0 from "./ClientNutritionInstructionItem.vue?vue&type=style&index=0&id=1ece3dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece3dc6",
  null
  
)

export default component.exports